module.exports = __webpack_public_path__ + "09ed2545f8ca6d01f8cbdb8dbc184f4f.png";